import React from 'react';

import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';

import {NavBar, NavLink} from 'components/ui-kit/NavBar';
import {ROUTE} from 'core/routes';

import {RecallControl} from '../RecallControl';
import {ControlsTopWrapper} from '../styled';

export const GridsNavigation = () => {
    const {t} = useTranslation();
    const location = useLocation();
    const isFavoritesRoute = location.pathname === ROUTE.REGISTRIES_GTIN_FAVORITES;

    return (
        <ControlsTopWrapper>
            <NavBar style={{marginLeft: 'auto'}}>
                <NavLink
                    exact
                    to={ROUTE.REGISTRIES_GTIN_FAVORITES}
                    isActive={() => isFavoritesRoute}
                >
                    {t('pages.registries.gtins.tabs.favorites')}
                </NavLink>
                <NavLink exact to={ROUTE.REGISTRIES_GTIN_MY_CREATED}>
                    {t('pages.registries.gtins.tabs.myCreatedProducts')}
                </NavLink>
                <NavLink exact to={ROUTE.REGISTRIES_GTIN_ALL}>
                    {t('pages.registries.gtins.tabs.allProducts')}
                </NavLink>
            </NavBar>
            <RecallControl />
        </ControlsTopWrapper>
    );
};
